import { useEffect } from "react";

function useSendHeightToParent() {
  useEffect(() => {
    const sendHeightToParent = () => {
      // NOTE: Only offsetHeight will both increase and decrease when the content changes.
      const height = document.documentElement.offsetHeight;
      window.parent.postMessage(height, "*");
    };

    window.addEventListener("load", sendHeightToParent);
    window.addEventListener("resize", sendHeightToParent);
    window.addEventListener("DOMContentLoaded", sendHeightToParent);

    const observer = new MutationObserver(sendHeightToParent);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    // Cleanup event listeners and observer on component unmount
    return () => {
      window.removeEventListener("load", sendHeightToParent);
      window.removeEventListener("resize", sendHeightToParent);
      window.removeEventListener("DOMContentLoaded", sendHeightToParent);
      observer.disconnect();
    };
  }, []);
}

export default useSendHeightToParent;
